import React, {FunctionComponent} from "react";
import {RouteComponentProps, Router} from "@reach/router";
import {DownloadPage} from "./downloadPage";

export const DownloadModule: FunctionComponent<RouteComponentProps> = props => {
	return <Router>
		<DownloadPage path="/:fileId"/>
	</Router>;
}
